module.exports = __webpack_public_path__ + "img/huc-click.ac9781f2.png";